const API_PREFIX = '/api';

export const request = async (url, settings = {}) => {
    let res;
    let data = null;
    try {
        res = await fetch(`${API_PREFIX}${url}`, settings);
        if(!res.ok) {
            throw data;
        }
        if(res.status !== 204) {
            data = await res.json();
        }
    } catch(err) {
        throw err;
    }
    return data;
};
